import React, {useEffect, useRef, useState} from 'react';
import styles from './../Search/Search.module.css';
import {searchEntreprises, searchGlobal} from "../../services/SearchService";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch} from "@fortawesome/free-solid-svg-icons";

const SearchGlobal = ({ onSearch = null, placeholder = "Rechercher nom, adresse, ville, description ..." }) => {
    const [query, setQuery] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const searchRef = useRef(null);

    const fetchSuggestions = async (value) => {
        if (!value) {
            setSuggestions([]);
            return;
        }
        const response = await searchGlobal(value);
        setSuggestions(response.result);
    };

    const handleInputChange = async (e) => {
        const value = e.target.value;
        setQuery(value);
        await fetchSuggestions(value);
    };

    const handleSuggestionClick = (suggestion) => {
        setQuery(suggestion.label);
        if (onSearch) {
            onSearch(suggestion);
        }
        setSuggestions([]);

        if (suggestion.url) {
            window.location.href = suggestion.url;
        }
    };

    const handleClickOutside = (event) => {
        if (searchRef.current && !searchRef.current.contains(event.target)) {
            setSuggestions([]);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div style={{ display: "flex", flexDirection: "row" }} ref={searchRef}>
            <div className={`${styles.searchForm} ${styles.searchGlobalForm}`}>
                <div className={styles.searchBar}>
                    <input
                        type="text"
                        placeholder={placeholder}
                        value={query}
                        onChange={handleInputChange}
                        onClick={handleInputChange}
                        className={styles.searchInput}
                    />
                    <button>
                        <FontAwesomeIcon icon={faSearch}/>
                    </button>
                </div>

                <div className={styles.listeDeroulanteContainer}>
                    {suggestions.length > 0 && (
                        <ul className={styles.suggestion}>
                            {suggestions.map(suggestion => (
                                <li key={suggestion.url} onClick={() => handleSuggestionClick(suggestion)}>
                                    <span className={styles.suggestionType}>{suggestion.type}</span>
                                    <Link to={suggestion.url}>{suggestion.label}</Link>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SearchGlobal;
